
export const DocumentRequestSource = {
    Internal: 0,
    InternalAndPublic: 1,
    Public: 2,
}

